import { APIClient } from '../../helpers/api_helper';
const AxiosClient = new APIClient()
const generatePreAuthtenticatedRequestForOCI =(data) => AxiosClient.post('/generate-preauth-request', data);
export {
    generatePreAuthtenticatedRequestForOCI,
}